import { getFarmsPriceHelperLpFiles } from '@pancakeswap/farms/constants/priceHelperLps/getFarmsPriceHelperLpFiles'
import { ChainId } from '@pancakeswap/sdk'
import PoolsEthereumPriceHelper from './pools/1'
import PoolsGoerliPriceHelper from './pools/5'
import PoolsBscPriceHelper from './pools/56'
import PoolsBscTestnetPriceHelper from './pools/97'
import PoolsKasplexTestnetPriceHelper from './pools/167012'
import PoolsIgraTestnetPriceHelper from './pools/19416'
import PoolsKasplexMainnetPriceHelper from './pools/202555'

export { getFarmsPriceHelperLpFiles }

export const getPoolsPriceHelperLpFiles = (chainId: ChainId) => {
  switch (chainId) {
    case ChainId.BSC:
      return PoolsBscPriceHelper
    case ChainId.BSC_TESTNET:
      return PoolsBscTestnetPriceHelper
    case ChainId.KASPLEX_TESTNET:
      return PoolsKasplexTestnetPriceHelper
    case ChainId.IGRA:
      return PoolsIgraTestnetPriceHelper
    case ChainId.KASPLEX_MAINNET:
      return PoolsKasplexMainnetPriceHelper
    case ChainId.ETHEREUM:
      return PoolsEthereumPriceHelper
    case ChainId.GOERLI:
      return PoolsGoerliPriceHelper
    default:
      return []
  }
}
